import { c as _c } from "react/compiler-runtime";
import { getOrgEntityStatusesByIdOptions, getOrgEntityStatusesOptions } from '@onefootprint/fetch-dashboard';
import type { EntityOrgStatus } from '@onefootprint/request-types/dashboard';
import { useQueries, useQuery } from '@tanstack/react-query';

// These don't change often, so we want to reuse the results. Expires after 15 minutes
const STALE_TIME = 1000 * 60 * 15;
export const useGetStatuses = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      ...getOrgEntityStatusesOptions({}),
      staleTime: STALE_TIME
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return useQuery(t0);
};

/** Join active statuses with any deactivated statuses currently in use by this action node. */
export const useGetStatusesWithDeactivated = currentStatusIds => {
  const $ = _c(13);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      ...getOrgEntityStatusesOptions(),
      staleTime: STALE_TIME
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const activeQuery = useQuery(t0);
  let t1;
  if ($[1] !== activeQuery.data) {
    t1 = new Set(activeQuery.data?.map(_temp));
    $[1] = activeQuery.data;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const activeIds = t1;
  let t2;
  let t3;
  if ($[3] !== activeIds || $[4] !== activeQuery.isSuccess || $[5] !== currentStatusIds) {
    const extraStatusIds = Array.from(new Set(currentStatusIds.filter(id => !activeIds.has(id))));
    t2 = useQueries;
    t3 = {
      queries: extraStatusIds.map(id_0 => ({
        ...getOrgEntityStatusesByIdOptions({
          path: {
            id: id_0
          }
        }),
        staleTime: STALE_TIME,
        enabled: activeQuery.isSuccess
      }))
    };
    $[3] = activeIds;
    $[4] = activeQuery.isSuccess;
    $[5] = currentStatusIds;
    $[6] = t2;
    $[7] = t3;
  } else {
    t2 = $[6];
    t3 = $[7];
  }
  const deactivatedQueries = t2(t3);
  let t4;
  if ($[8] !== activeQuery.data || $[9] !== deactivatedQueries) {
    const deactivatedStatuses = deactivatedQueries.map(_temp2).filter(_temp3);
    let t5;
    if ($[11] !== activeQuery.data) {
      t5 = activeQuery.data ?? [];
      $[11] = activeQuery.data;
      $[12] = t5;
    } else {
      t5 = $[12];
    }
    t4 = [...t5, ...deactivatedStatuses];
    $[8] = activeQuery.data;
    $[9] = deactivatedQueries;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};
function _temp(s) {
  return s.id;
}
function _temp2(q) {
  return q.data;
}
function _temp3(s_0) {
  return s_0 != null;
}